import { baseApi } from "../../redux/baseAPI";

export const immunizationApi = baseApi.injectEndpoints({
  tagTypes: ["Immunization", "Charts"],
  endpoints: (builder) => ({
    getImmunizations: builder.query({
      query: (data) => {
        return {
          url: `/immunizations/indexx.json?`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      providesTags: ["Immunization"],
      // (result) =>
      //   result.data
      //     ? [
      //         ...result.data.map(({ id }) => ({ type: "Immunization", id })),
      //         { type: "Immunization", id: "LIST" },
      //       ]
      //     : [{ type: "Immunization", id: "LIST" }],
    }),
    getEligibility: builder.query({
      query: (data) => {
        return {
          url: `/immunizations/get_eligibility.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getImmunities: builder.query({
      query: (data) => {
        return {
          url: `/immunizations/immunities.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getLots: builder.query({
      query: (data) => {
        return {
          url: `/immunizations/lots.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getImmunizationMetaData: builder.query({
      query: (data) => {
        return {
          url: `/utilities/immunization_metadata.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getVaccines: builder.query({
      query: (data) => {
        return {
          url: `/immunizations/vaccines_search.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    searchProviders: builder.query({
      query: (params) => {
        return {
          url: `/providers.json`,
          method: "GET",
          params:{drfirst_registered:params.drfirst_registered,role:params.role, keyword: params.keyword}
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    updateResult: builder.mutation({
      query: (body) => ({
        url: `/labs/save_results.json`,
        method: "POST",
        data: body,
        params: { pid: body.pid },
      }),
      invalidatesTags: ["Immunization"],
      transformResponse: (response, meta, arg) => response.response,
    }),
    updateAdministerVaccine: builder.mutation({
      query: (body) => ({
        url: `/immunizations/administer_vaccine.json`,
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["Immunization", "Charts"],
      transformResponse: (response, meta, arg) => response.response,
    }),
    deleteAdministerVaccine: builder.mutation({
      query: (body) => ({
        url: `/immunizations/VaccineDelete.json`,
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["Immunization", "Charts"],
      transformResponse: (response, meta, arg) => response.response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          immunizationApi.util.updateQueryData(
            "getImmunizations",
            id,
            (draft) => {
              Object.assign(draft, patch);
            }
          )
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    deleteVaccine: builder.mutation({
      query: (body) => ({
        url: `/immunizations/vaccine_delete.json`,
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["Immunization"],
      transformResponse: (response, meta, arg) => response.response,
      async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          immunizationApi.util.updateQueryData(
            "getImmunizations",
            id,
            (draft) => {
              Object.assign(draft, patch);
            }
          )
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      // invalidatesTags: (result, error, { id }) => [
      //   { type: "Immunization", id },
      // ],
    }),
    updateOrderVaccine: builder.mutation({
      query: (body) => ({
        url: `/immunizations/order_vaccine.json`,
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["Immunization", "Charts"],
      transformResponse: (response, meta, arg) => response.response,
    }),
    updateScheduleVaccine: builder.mutation({
      query: (body) => ({
        url: `/immunizations/schedule_vaccine.json`,
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["Immunization", "Charts"],
      transformResponse: (response, meta, arg) => response.response,
    }),
    getPracticeLocations: builder.query({
      query: (body) => {
        return {
          url: `/practices/location_list.json`,
          method: "GET",
          // params: { pid: body.pid }
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    updateRecordVaccine: builder.mutation({
      query: (body) => ({
        url: `/immunizations/record_vaccine.json`,
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["Immunization", "Charts"],
      transformResponse: (response, meta, arg) => response.response,
    }),
    updateRefusalVaccine: builder.mutation({
      query: (body) => ({
        url: `/immunizations/refuse_vaccine.json`,
        method: "POST",
        data: body,
      }),
      invalidatesTags: ["Immunization", "Charts"],
      transformResponse: (response, meta, arg) => response.response,
    }),
    getImmunizationCharts: builder.query({
      query: (body) => {
        return {
          url: `/immunizations/charts.json`,
          method: "GET",
          params: { pid: body.pid }
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["Charts"],
    }),
    getChartDetails: builder.query({
      query: (body) => {
        return {
          url: `/immunizations/index2.json`,
          method: "GET",
          params: { record_id: body.record_id }
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    importPatientImmunization: builder.query({
      query: (body) => {
        return {
          url: `/immunizations/addImmunizationHistory.json`,
          method: "GET",
          params: { pid: body.pid }
        };
      },
      transformResponse: (response, meta, arg) => response.response.data || {},
      invalidatesTags: ["Charts"]
    }),
    syncImportImmunization: builder.query({
      query: (body) => {
        return {
          url: `/immunizations/evaluation_history_forecast.json`,
          method: "GET",
          params: { pid: body.pid, practice_id: body.practice_id }
        };
      },
      transformResponse: (response, meta, arg) => response.response.data || {},
      invalidatesTags: ["Immunization"],
    }),
    printImmunization: builder.query({
      query: (params) => {
        return {
          url: `/immunizations/generateListPdf.json`,
          method: "GET",
          params: params || {},
        };
      },
      transformResponse: (response, meta, arg) => response.response || {},
      // invalidatesTags: ["Charts"]
    })
  }),
});

export const {
  useGetImmunizationsQuery,
  useGetImmunizationMetaDataQuery,
  useGetVaccinesQuery,
  useUpdateAdministerVaccineMutation,
  useUpdateOrderVaccineMutation,
  useGetPracticeLocationsQuery,
  useGetImmunizationChartsQuery,
  useImportPatientImmunizationQuery,
  useUpdateRecordVaccineMutation,
  useUpdateRefusalVaccineMutation,
  useDeleteAdministerVaccineMutation,
  useDeleteVaccineMutation,
  useUpdateScheduleVaccineMutation,
  useGetChartDetailsQuery,
  useSearchProvidersQuery,
  useSyncImportImmunizationQuery
} = immunizationApi;
